// Ian - 2026-10-08 - Basket promotion add-to-basket (snippets/ian-cart-promo.liquid).
// One delegated click listener, because Envy replaces the drawer's body with innerHTML on
// every basket change, so the buttons are new elements each time. After the add it hands
// the rendered sections to Envy's own handlers: the drawer listens for update:cart:drawer,
// and the cart page's <cart-items> exposes renderCartSection(). Both then re-render the
// promo snippet from Liquid, which moves it on to the "claimed" state.
(() => {
  if (window.ianCartPromoInit) return;
  window.ianCartPromoInit = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const showError = (card, message) => {
    const error = card && card.querySelector('[data-ian-promo-error]');
    if (!error) return;
    error.textContent = message;
    error.hidden = false;
  };

  const updateCartCount = async () => {
    // Ian: same call Envy's own product cards make to refresh the header count
    try {
      if (!window.wetheme || typeof window.wetheme.updateCartCount !== 'function') return;
      const response = await fetch(`${window.routes.cart_url}?view=compare`);
      window.wetheme.updateCartCount(await response.json());
    } catch (e) {
      console.error('ian-cart-promo: cart count', e);
    }
  };

  // Ian - 2026-10-08 - Picker arrows. The rail is re-rendered on every basket change, so the
  // arrow state is recalculated on scroll (captured, since scroll doesn't bubble) and whenever
  // the drawer or cart page swaps in new HTML.
  const updateNav = (rail) => {
    const nav = rail && rail.parentElement && rail.parentElement.querySelector('[data-ian-promo-nav]');
    if (!nav) return;
    const max = rail.scrollWidth - rail.clientWidth;
    nav.hidden = max <= 2;
    const [prev, next] = nav.querySelectorAll('[data-ian-promo-scroll]');
    if (prev) prev.disabled = rail.scrollLeft <= 2;
    if (next) next.disabled = rail.scrollLeft >= max - 2;
  };
  const updateAllNav = () => document.querySelectorAll('[data-ian-promo-rail]').forEach(updateNav);

  document.addEventListener('scroll', (event) => {
    if (event.target instanceof Element && event.target.matches('[data-ian-promo-rail]')) updateNav(event.target);
  }, true);
  window.addEventListener('resize', updateAllNav);
  // Ian: batched to one check per frame, since apps on the page add nodes constantly
  let navPending = false;
  new MutationObserver(() => {
    if (navPending) return;
    navPending = true;
    requestAnimationFrame(() => { navPending = false; updateAllNav(); });
  }).observe(document.body, { childList: true, subtree: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAllNav);
  } else {
    updateAllNav();
  }

  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('[data-ian-promo-scroll]');
    if (!arrow) return;
    const rail = arrow.closest('.ian-cart-promo__offer')?.querySelector('[data-ian-promo-rail]');
    if (!rail) return;
    const card = rail.querySelector('[data-ian-promo-card]');
    const step = card ? card.getBoundingClientRect().width + 12 : rail.clientWidth * 0.8;
    // Ian: move by whole cards, two at a time, so a card never ends up half-shown at the start
    rail.scrollBy({ left: Number(arrow.dataset.ianPromoScroll) * step * 2, behavior: 'smooth' });
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-ian-promo-add]');
    if (!button || button.disabled) return;
    event.preventDefault();

    const card = button.closest('[data-ian-promo-card]');
    const select = card && card.querySelector('[data-ian-promo-variant]');
    const variantId = Number(select ? select.value : button.dataset.variantId);
    if (!variantId) return;

    const cartItems = document.querySelector('cart-items[data-section-id]');
    const sections = ['cart-drawer'];
    if (cartItems) sections.push(cartItems.dataset.sectionId);

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: sections.join(',') })
      });
      const json = await response.json();

      if (!response.ok || json.status) {
        showError(card, json.description || json.message || 'Sorry, that could not be added.');
        button.disabled = false;
        button.removeAttribute('aria-busy');
        return;
      }

      if (window.eventBus) window.eventBus.emit('update:cart:drawer', json);
      if (cartItems && typeof cartItems.renderCartSection === 'function') cartItems.renderCartSection(json);
      updateCartCount();
    } catch (e) {
      console.error('ian-cart-promo: add', e);
      showError(card, 'Sorry, that could not be added.');
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();
